import {
    Bubble
} from './model/bubble.js';

export const bubblesArray = [
    new Bubble('small-sprite-sexist', 0),
    new Bubble('small-sprite-sexist', 1),
    new Bubble('small-sprite-sexist', 2),
    new Bubble('small-sprite-sexist', 3),
    new Bubble('small-sprite-sexist', 4),
    new Bubble('small-sprite-sexist', 5),
    new Bubble('small-sprite-nonsexist', 0),
    new Bubble('small-sprite-nonsexist', 1),
    new Bubble('small-sprite-nonsexist', 2),
    new Bubble('small-sprite-nonsexist', 3),
    new Bubble('small-sprite-nonsexist', 4),
    new Bubble('small-sprite-nonsexist', 5),
    new Bubble('regular-sprite-sexist', 0),
    new Bubble('regular-sprite-sexist', 1),
    new Bubble('regular-sprite-sexist', 2),
    new Bubble('regular-sprite-sexist', 3),
    new Bubble('regular-sprite-sexist', 4),
    new Bubble('regular-sprite-sexist', 5),
    new Bubble('regular-sprite-sexist', 6),
    new Bubble('regular-sprite-sexist', 7),
    new Bubble('regular-sprite-sexist', 8),
    new Bubble('regular-sprite-sexist', 9),
    new Bubble('regular-sprite-sexist', 10),
    new Bubble('regular-sprite-sexist', 11),
    new Bubble('regular-sprite-sexist', 12),
    new Bubble('regular-sprite-sexist', 13),
    new Bubble('regular-sprite-sexist', 14),
    new Bubble('regular-sprite-sexist', 15),
    new Bubble('regular-sprite-nonsexist', 0),
    new Bubble('regular-sprite-nonsexist', 1),
    new Bubble('regular-sprite-nonsexist', 2),
    new Bubble('regular-sprite-nonsexist', 3),
    new Bubble('regular-sprite-nonsexist', 4),
    new Bubble('regular-sprite-nonsexist', 5),
    new Bubble('regular-sprite-nonsexist', 6),
    new Bubble('regular-sprite-nonsexist', 7),
    new Bubble('regular-sprite-nonsexist', 8),
    new Bubble('regular-sprite-nonsexist', 9),
    new Bubble('regular-sprite-nonsexist', 10),
    new Bubble('regular-sprite-nonsexist', 11),
    new Bubble('regular-sprite-nonsexist', 12),
    new Bubble('regular-sprite-nonsexist', 13),
    new Bubble('large-sprite-sexist', 0),
    new Bubble('large-sprite-sexist', 1),
    new Bubble('large-sprite-sexist', 2),
    new Bubble('large-sprite-sexist', 3),
    new Bubble('large-sprite-sexist', 4),
    new Bubble('large-sprite-sexist', 5),
    new Bubble('large-sprite-sexist', 6),
    new Bubble('large-sprite-sexist', 7),
    new Bubble('large-sprite-sexist', 8),
    new Bubble('large-sprite-sexist', 9),
    new Bubble('large-sprite-sexist', 10),
    new Bubble('large-sprite-sexist', 11),
    new Bubble('large-sprite-sexist', 12),
    new Bubble('large-sprite-nonsexist', 0),
    new Bubble('large-sprite-nonsexist', 1),
    new Bubble('large-sprite-nonsexist', 2),
    new Bubble('large-sprite-nonsexist', 3),
    new Bubble('large-sprite-nonsexist', 4),
    new Bubble('large-sprite-nonsexist', 5),
    new Bubble('large-sprite-nonsexist', 6),
    new Bubble('large-sprite-nonsexist', 7),
    new Bubble('large-sprite-nonsexist', 8),
    new Bubble('large-sprite-nonsexist', 9),
    new Bubble('large-sprite-nonsexist', 10),
    new Bubble('large-sprite-nonsexist', 11),
    new Bubble('large-sprite-nonsexist', 12),
    new Bubble('large-sprite-nonsexist', 13),
    new Bubble('large-sprite-nonsexist', 14),
];
